<!--
  name : 이예닮
  desc : 사용자 설정
  date : 2021-07-19
-->
<template>
  <v-container id="set_org" class="con_mpw">
    <!--사용자 설정-->
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-row no-gutters class="search_bar_02 justify-center aling-center">
        <v-col cols="12">
          <v-autocomplete class="inputH48_02 H64xx serch_W_mg"
            :items="userList"
            label="사용자 설정"
            outlined
            hide-details
          >
            <template v-slot:selection="data">
              <v-list-item close hide-details class="form_slct">
                <!-- img -->
                <v-avatar left class="user_pic_s pp" v-if="data.item.group == '개인'">
                  <v-img :src="data.item.avatar" style="height: 100%; border-radius: 15px;" v-if="data.item.avatar != null"></v-img>
                </v-avatar>
                <v-avatar left class="user_pic_s cpn" v-if="data.item.group == '기업'">
                  <v-img :src="data.item.avatar" style="height: 100%; border-radius: 15px;" v-if="data.item.avatar != null"></v-img>
                </v-avatar>
                <!-- list -->
                <v-list-item-content>
                  <v-list-item-title>
                    {{ data.item.name }}
                    ({{ data.item.text | regNumFilter }})
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>

            <template v-slot:item="data">
              <template>
                <!-- img -->
                <v-avatar left class="user_pic_s pp" v-if="data.item.group == '개인'">
                  <v-img :src="data.item.avatar" style="height: 100%; border-radius: 15px;" v-if="data.item.avatar != null"></v-img>
                </v-avatar>
                <v-avatar left class="user_pic_s cpn" v-if="data.item.group == '기업'">
                  <v-img :src="data.item.avatar" style="height: 100%; border-radius: 15px;" v-if="data.item.avatar != null"></v-img>
                </v-avatar>
                <!-- list -->
                <v-list-item-content  @click="selectUser(data.item)">
                  <v-list-item-title>
                    {{ data.item.name }}
                    ({{ data.item.text | regNumFilter }})
                  </v-list-item-title>
                </v-list-item-content>
              </template>
            </template>

          </v-autocomplete>
        </v-col>

        <v-col cols="12" class="org_btnrow01">
          <v-btn class="btn17_C01" v-if="!tempOrg" @click="addCpn()"><span class="icon"></span><span class="icon cpn_add"></span>기업 생성</v-btn>
          <v-btn outlined class="btn17_00" @click="clickCpn"><span class="icon cpn_join"></span>기업 참여요청</v-btn>
          <v-btn outlined class="btn17_00" v-if="unapprovedOrg.length > 0" @click="requestCpn">요청현황</v-btn>
          <v-btn outlined class="btn17_00" v-if="tempOrgYN" @click="reqAuthQuestConfirm()">온라인 기업 인증</v-btn>
          <v-btn outlined class="btn17_00" v-if="tempOrgYN" @click="deleteOrgTemp(focusOrgInfo.organizationRegistrationNumber, focusOrgInfo.organizationName)">온라인 기업 인증 취소</v-btn>
        </v-col>
      </v-row>
    </v-form>

    <!--사용자 정보-->
    <v-row no-gutters class="con_mb40">
      <div class="dot_tt">사용자 정보</div>

      <v-col cols="12" class="set_pic_con">
        <div class="org_pic_cov">
          <div class="org_pic pp">
            <v-img :src="accountform.avatar" style="height: 100%; border-radius: 15px;" v-if="accountform.avatar != ''"></v-img>
          </div>
          <v-btn class="btnO_C01 edit_pic" @click="addImg(accountform.chainAddress, accountform.avatar)"><span class="icon"></span></v-btn>
        </div>

        <div class="org_info_cov">
          <v-row no-gutters>
            <v-col cols="12">
              <ul class="pattern_ulTxtBox ofHmb20">
                <li>
                  <span class="txt_tt03">이름</span>
                  <span class="txt_txt01 no_pr">{{this.accountform.name}}</span>
                </li>
                <li>
                  <span class="txt_tt03">주소</span>
                  <span class="txt_txt01 no_pr">{{this.accountform.addr_main}}</span>
                </li>
                <li>
                  <span class="txt_tt03">연락처</span>
                  <span class="txt_txt01 no_pr">{{this.accountform.phone}}</span>
                </li>
              </ul>
              <v-row no-gutters class="posiR_W100">
                <v-btn text class="btn_txt02" @click="personInfo">수정<span class="icon arr"></span></v-btn>
                <v-btn text class="btn_txt02" @click="changePassword">비밀번호 변경<span class="icon arr"></span></v-btn>
                <v-btn text class="btn_txt02" @click="terminateMember">회원탈퇴<span class="icon arr"></span></v-btn>
              </v-row>
            </v-col>
          </v-row>
        </div>

      </v-col>
    </v-row>

    <!--기업 정보-->
    <v-row no-gutters class="con_mb40"  v-if="userGubun === '기업'" >
      <div class="dot_tt">기업 정보</div>
      <v-col cols="12" class="set_pic_con">

        <div class="org_pic_cov">
          <div class="org_pic cpn">
            <v-img :src="focusOrgInfo.avatar" style="height: 100%; border-radius: 15px;" v-if="focusOrgInfo.avatar != ''"></v-img>
          </div>
          <v-btn class="btnO_C01 edit_pic" v-if="isAdmin" @click="addImg(focusOrgInfo.chainAddress,focusOrgInfo.avatar)"><span class="icon"></span></v-btn>
        </div>

        <div class="org_info_cov">
          <v-row no-gutters>
            <v-col cols="12">
              <ul class="pattern_ulTxtBox">
                <li>
                  <span class="txt_tt03">기업명</span>
                  <span class="txt_txt01 no_pr">{{this.focusOrgInfo.organizationName}}</span>
                </li>
              </ul>
            </v-col>
            <v-col cols="12">
              <ul class="pattern_ulTxtBox">
                <li>
                  <span class="txt_tt03">대표자명</span>
                  <span class="txt_txt01 no_pr">{{this.focusOrgInfo.presidentName}}</span>
                </li>
                <li>
                  <span class="txt_tt03">주소</span>
                  <span class="txt_txt01 no_pr">{{this.focusOrgInfo.organizationAddress}}</span>
                </li>
                <li>
                  <span class="txt_tt03">연락처</span>
                  <span class="txt_txt01 no_pr">{{this.focusOrgInfo.organizationContact | formatContact}}</span>
                </li>
                <v-row no-gutters class="posiR_W100" v-if="isAdmin">
                  <v-btn text class="btn_txt02" @click="companyInfo()">수정<span class="icon arr"></span></v-btn>
                </v-row>
              </ul>
            </v-col>
            <v-col cols="12">
              <ul class="pattern_ulTxtBox">
                <li>
                  <span class="txt_tt03">기업 관리자</span>
                  <span class="txt_txt01 no_pr">{{this.adminUsrName}}</span>
                  <span class="txt_txt02"> {{this.adminUsrEmail}}</span>
                  <v-row no-gutters class="posiR_W100 mt-1" v-if="isAdmin">
                    <v-btn text class="btn_txt02" @click="transferOrgAdminPopup(adminUsrId, true)">변경<span class="icon arr"></span></v-btn>
                  </v-row>
                </li>
                <li>
                  <span class="txt_tt03">전자계약 관리자</span>
                  <span class="txt_txt01 no_pr">{{this.cadminUsrName}}</span>
                  <span class="txt_txt02"> {{this.cadminUsrEmail}}</span>
                  <v-row no-gutters class="posiR_W100 mt-1" v-if="isAdmin">
                    <v-btn text class="btn_txt02" @click="transferOrgAdminPopup(cadminUsrId, false)">변경<span class="icon arr"></span></v-btn>
                  </v-row>
                </li>
                <li>
                  <span class="txt_tt03">기업 계약 이메일</span>
                  <span class="txt_txt01 no_pr">{{this.focusOrgInfo.organizationEmail}}</span>
                  <v-row no-gutters class="posiR_W100 mt-1">
                    <v-btn text class="btn_txt02" @click="orgMailPopup">변경<span class="icon arr"></span></v-btn>
                  </v-row>
                </li>
              </ul>
            </v-col>
            <v-col cols="12">
                <div v-if="!tempOrgYN" class="posiR_W100"><v-btn text class="btn_txt02" @click="leaveOrgQuest(focusOrgInfo.organizationSequence, focusOrgInfo.organizationName)">기업탈퇴<span class="icon arr"></span></v-btn></div>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>

    <!--(팝업) 사진등록-->
    <v-dialog
      v-model="dialogImg" @keydown.esc="dialogImg = false"
      max-width="800px"
      persistent>
      <v-card id="popStyle03">
        <v-card-title class="title">
          사진등록
          <v-btn fab class="popBtnClose" @click="dialogImg = false"></v-btn>
        </v-card-title>
        <!--팝업 내용-->
        <v-card-text>
          <v-row no-gutters class="justify-center popCon">
            <div class="org_pic_cov">
              <div class="org_pic">
                <v-img :src="imgAvatar" style="height: 100%; border-radius: 15px;" v-if="imgAvatar != ''"></v-img>
                <v-btn class="del_pic btnO_C04 delete" @click="deleteImg()"><span class="icon"></span></v-btn>
              </div>
            </div>
            <v-col cols="12" class="mt-6">
              <v-file-input class="inputH48_01 W100"
                accept="image/png, image/jpeg, image/bmp, image/gif"
                placeholder="102px 이상의 정사각 이미지"
                prepend-icon="mdi-camera"
                messages="5MB 이하의 이미지 파일을 업로드 할 수 있습니다."
                label="프로필 사진 등록"
                outlined
                dense
                @change="UserImgUpload"
                v-model="userImg"
              ></v-file-input>
            </v-col>
          </v-row>
        </v-card-text>
        <!--button-->
        <v-card-actions class="justify-center">
          <v-btn class="btn_C01" text @click="uploadImg()" >수정</v-btn>
          <v-btn text @click="dialogImg = false" >닫기</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--(팝업)관리자 변경-->
    <v-dialog
      v-model="dialog03" @keydown.esc="dialog03 = false"
      max-width="800px"
      persistent>
      <v-card id="popStyle03">
        <v-card-title class="title">
          <span v-if="transferType">기업 관리자 변경</span>
          <span v-else>전자계약 관리자 변경</span>
          <v-btn fab class="popBtnClose" @click="dialog03 = false"></v-btn>
        </v-card-title>
        <!--팝업 내용-->
        <v-card-text>
            <!--list-->
            <v-row class="align-center pop_list_carD02" v-if="orgUsrList != ''">
              <v-col cols="12" sm="12" md="12" lg="12">
                <v-card  v-for="(orgusrlist, index) of orgUsrList" :key="index" class="list_carD02_con" >
                  <v-checkbox v-model="checkOrgAdminList" :value="index" class="coNlist_chk02" @click="addOrgAdmin(orgusrlist)"></v-checkbox>
                  <v-list-item class="carD_box_chkO">
                    <div class="org_pic_s cpn mr-1">
                      <v-img :src="orgUsrImgList[index]" style="height: 100%; border-radius: 15px;"></v-img>
                    </div>
                    <ul class="list_carD02_ulTxtBox">
                      <li class="txtCon01">
                        <span class="txt_txt01 no_pr">{{orgusrlist.userName}}</span>
                        <span class="txt_txt02">({{orgusrlist.userEmail}})</span>
                      </li>
                      <li class="txtCon02">
                        <span class="txt_txt_r">{{orgusrlist.userCtr | formatContact}}</span>
                      </li>
                    </ul>
                  </v-list-item>
                </v-card>
              </v-col>
            </v-row>
          <!-- </v-row> -->
        </v-card-text>
        <!--button-->
        <v-card-actions class="justify-center">
          <v-btn class="btn_C01" text @click="changeOrgAdmin()" >변경</v-btn>
          <v-btn text @click="cancelOrgAdmin()">취소</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--(팝업)기업 계약 이메일 변경-->
    <v-dialog
      v-model="dialog04" @keydown.esc="dialog04 = false"
      max-width="600px"
      persistent>
      <v-card id="popStyle03">
        <v-card-title class="title">
          기업 계약 이메일 변경
          <v-btn fab class="popBtnClose"></v-btn>
        </v-card-title>
        <!--팝업 내용-->
        <v-card-text>
          <v-row no-gutters class="justify-center popCon">
            <div class="popCon_txt">입력하신 이메일 계정으로 기업 계약 메일이 전송됩니다.</div>
            <div class="popCon_input_W100_cov">
              <v-text-field ref="emailRules" class="inputH48_01"
                label="이메일"
                placeholder="변경할 이메일 주소를 입력하세요"
                v-model="editContrctEmail"
                :rules="rules.emailRules"
                maxlength="1000"
                outlined
                dense
              >
              </v-text-field>
            </div>
          </v-row>
        </v-card-text>
        <!--button-->
        <v-card-actions class="justify-center">
          <v-btn class="btn_C01" @click="editContractMail()">변경</v-btn>
          <v-btn text @click="dialog04 = false">취소</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--(팝업)기업 참여요청-->
    <v-dialog
      v-model="joinCpn" @keydown.esc="joinCpn = false"
      max-width="800px"
      persistent>
      <v-card id="popStyle03">
        <v-card-title class="title">
          기업 참여요청
          <v-btn fab class="popBtnClose" @click="joinCpn = false"></v-btn>
        </v-card-title>
        <!--팝업 내용-->
        <v-card-text>
          <v-row no-gutters class="justify-center popCon">
            <v-col cols="12" class="pd-0">
              <div class="txtst_info_gray row_mb-20">* 참여 요청할 기업의 사업자등록번호를 검색해 주세요.</div>
            </v-col>
            <v-col cols="12" sm="10" md="10" lg="10" class="justify-center">
              <v-text-field class="inputH48_02 serch_W_mg dpnone"
                  label="검색어"
                  v-model="searchReqRegNum"
                  placeholder="사업자번호 검색"
                  maxlength="10"
                  outlined
                ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" class="justify-start">
              <v-btn class="btn17_C01" @click="isValidRegNumforReqGroup"><span class="icon search"></span></v-btn>
            </v-col>
            <v-col cols="12" v-if="formSearchReqGroupOrg.organizationName !== ''">
              <!--리스트-->
              <v-row class="align-center pop_list_carD03">
                <v-col cols="12" sm="12" md="12" lg="12">
                <v-card class="list_carD02_con" @click="dialogIdtest = true">
                  <v-checkbox class="coNlist_chk02"></v-checkbox>
                  <v-list-item class="carD_box_chkO">
                    <div class="org_pic_s cpn mr-1">
                      <v-img :src="this.formSearchReqGroupOrg.organizationimg" style="height: 100%; border-radius: 15px;"></v-img>
                    </div>
                    <ul class="list_carD02_ulTxtBox">
                      <li class="txtCon01">
                        <span class="txt_txt01 no_pr">{{this.formSearchReqGroupOrg.organizationName}}</span>
                        <span class="txt_txt02">({{this.formSearchReqGroupOrg.organizationRegistrationNumber| regNumFilter}})</span>
                      </li>
                      <li class="txtCon02">
                        <span class="txt_txt_l">{{this.formSearchReqGroupOrg.presidentName}}</span>
                        <span class="txt_txt_r">{{this.formSearchReqGroupOrg.organizationContact | formatContact }}</span>
                      </li>
                    </ul>
                  </v-list-item>
                </v-card>
                </v-col>
              </v-row>
              <ul class="pattern_ul_terms row_mb-40">
                <li>- 기업 관리자 승인 후에 기업에 등록됩니다.</li>
              </ul>
            </v-col>
          </v-row>
        </v-card-text>
        <!--button-->
        <v-card-actions class="justify-center">
          <v-btn class="btn_C01" text  @click="submitOrgGroupUser()">참여요청</v-btn>
          <v-btn text @click="joinCpn = false">취소</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <pubCert ref="pubCert" :cert-regno="focusOrgInfo?focusOrgInfo.organizationRegistrationNumber:''" @childs-event="purCertResult"></pubCert>
    <personInfo ref="personInfo" :accountform="accountform" ></personInfo>
    <changePassword ref="changePassword" :accountform="accountform"></changePassword>
    <terminateMember ref="terminateMember" :accountform="accountform"></terminateMember>
    <companyInfo ref="companyInfo" :focusOrgInfo="focusOrgInfo" ></companyInfo>
    <addCpn ref="addCpn"></addCpn>
    <requestCpn ref="requestCpn" :unapprovedOrg="unapprovedOrg" :unapprovedOrgimg="unapprovedOrgimg"></requestCpn>
    <s-loading ref="loading"></s-loading>
    <s-confirm ref="confirm"></s-confirm>
  </v-container>
</template>

<script>
import { getOrgListAdm, getOrgList, getOrgInfo, removeRequestTempOrginfo, updateOrgAdminUser, createOrgGroupUser, editOrgEmailinfo, transferAdminUser, authOrg, isLastUser, leaveOrgUser, deleteOrgTemp } from '@/api/orgconfig'
import { uploadUserImg, deleteUserImg, getUserImgList } from '@/api/userImg'
import { getUserInfo } from '@/api/user'
import { autoHypenPhone } from '@/api/common'
import { orgNumSearchList } from '@/api/join'

// 팝업
import personInfo from '@/views/setting/popup/personInfo'
import changePassword from "./popup/changePassword";
import terminateMember from "./popup/terminateMember";
import companyInfo from '@/views/setting/popup/companyInfo'
import addCpn from '@/views/setting/popup/addCpn'
import requestCpn from '@/views/setting/popup/requestCpn'
import pubCert from '@/components/pubCertCompany'

export default {
  name: 'orgConfig',
  components: {
    personInfo,
    companyInfo,
    addCpn,
    requestCpn,
    pubCert,
    changePassword,
    terminateMember
  },
  filters: {
    formatContact: function (value) {
      if (value) {
        return autoHypenPhone(value)
      }
    },
    regNumFilter: function (value) {
      if (value) {
        return String(value).replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3')
      }
    }
  },
  created () {
  },
  mounted () {
    this.user = this.$store.state.user
    if(this.$store.state.user.orgaddr) {
      this.activeName = 'company'
    } else {
      this.activeName = 'personal'
    }
    this.getOrgList()
  },
  data () {
    return {
      isAdmin: false, // 관리자 유무
      activeName: '', // company OR personal

      dialogImg: false, // 사진 등록
      dialog01: false,  // 개인정보
      dialog02: false,  // 기업정보
      dialog03: false,  // 관리자 변경
      dialog04: false,  // 기업 계약 이메일 변경
      joinCpn: false, // 기업 참여요청
      addCpn04: false,  // 기업 생성
      tempOrgYN: false, // 기업 요청유무

      tempOrg:'',  // 기업인증 체크
      unapprovedOrg: [],  // 기업 참여요청 현황
      unapprovedOrgimg: [],

      // 사용자 설정
      valid: '', // model
      userGubun: '', // 기업 체크
      userid: '', // 로그인 한 user ID
      userList: [], // list
      userBaseData: [], // list
      orgList: [],  // 기업 list
      imgList: [],  // 기업 img list

      // 유저 정보
      accountform: {
        userid: '',
        name: '',
        email: '',
        addr_main: '',
        chainAddress: '',
        phone: ''
      },

      // 기업 정보
      focusOrgInfo: {
        organizationName: '',
        creationDatetimesubstr: '',
        organizationRegistrationNumber: '',
        presidentName: '',
        organizationAddress: '',
        organizationContact: '',
        organizationSequence: '',
        organizationEmail: '',
        chainAddress: '',
        avatar: '',
      },

      // 기업 관리자
      adminUsrId: '',
      adminUsrName: '',
      adminUsrEmail: '',

      // 전자계약 관리자
      cadminUsrId: '',
      cadminUsrName: '',
      cadminUsrEmail: '',

      // 기업 참여요청
      searchReqRegNum: '',
      formSearchReqGroupOrg: {
        organizationSequence: '',
        organizationName: '',
        organizationRegistrationNumber: '',
        presidentName: '',
        organizationAddress: '',
        organizationContact: '',
        organizationimg: '',
      },

      // 이미지 등록
      userImg: '',
      ImgData: '',
      imgAvatar: '',
      imgChainAddress: '',
      UserImgFile: {
        id: '',
        url: '',
        originUrl: ''
      },

      // 기업 관리자 변경
      adminPicked:[],
      transferType: false,
      changeOrgAdminList: [],
      checkOrgAdminList: [],
      orgUsrList: [],
      orgUsrImgList: [],
      pageParam: {
        page: 0,
        size: 5
      },

      // 기업 계약 이메일 변경
      OrgAdmin:'',
      editContrctEmail: '',

      rules: {
				emailRules: [
					v => !!v || '이메일을 입력해 주세요.',
					v => /.+@.+\..+/.test(v) || '이메일 형식을 확인 해주세요.',
				]
			}
    }
  },
  methods: {
    // User Setup Data
    getOrgList() {
      this.Name = this.userName
      this.userList = []
      var userBaseData = []
      var UserImgFile = ''

      // 유저정보 받아오는 곳
      getUserInfo(JSON.stringify({ userid: this.user.userid })).then(Response => {
        if (Response.rdata !== undefined && Response.rdata.rcode === 20000) {
          this.accountform.userid = Response.rdata.user.userId
          this.accountform.name = Response.rdata.user.userName
          this.accountform.email = Response.rdata.user.userEmail
          this.accountform.addr_main = Response.rdata.user.userAddress
          this.accountform.avatar = this.user.userImg
          this.accountform.chainAddress = Response.rdata.user.chainAddress
          this.accountform.phone = autoHypenPhone(Response.rdata.user.userCtr)

          userBaseData = { header: '개인' }
          this.userList.push(userBaseData)

          userBaseData = {
            text: autoHypenPhone(Response.rdata.user.userCtr),
            chainAddress: Response.rdata.user.chainAddress,
            name: Response.rdata.user.userName,
            group: '개인',
            avatar: this.user.userImg,
            index: 0,
            TempGroup: false
          }
          this.userList.push(userBaseData)
        }
        // 전체 기업 목록
        getOrgList().then(response => {
          if(response.rdata !== undefined && response.rdata.rcode === 20000) {
            this.orgList = response.rdata.list

            userBaseData = { header: '기업' }
            this.userList.push(userBaseData)

            for (var i in this.orgList) {
              if(response.rdata.imgList[i]) {
                UserImgFile = process.env.VUE_APP_URL_USER_THUMBNAIL + response.rdata.imgList[i].imgSequence
              } else {
                UserImgFile = ''
              }

              userBaseData = {
                text: this.orgList[i].organizationRegistrationNumber,
                chainAddress: this.orgList[i].chainAddress,
                name: this.orgList[i].organizationName,
                group: '기업',
                avatar: UserImgFile,
                index: i,
                TempGroup: false
              }
              this.userList.push(userBaseData)
            }
          }  else {
            this.orgList=[]
            this.imgList=[]
          }
        })
      })
      // 인증 대기 기업
      getOrgListAdm().then(response => {
        if (response.rdata.unapprovedOrg !== undefined && response.rdata.unapprovedOrg !== null) {
          this.unapprovedOrg = response.rdata.unapprovedOrg
          for (var j in this.unapprovedOrg) {
            getUserImgList(JSON.stringify({ chainAddress: response.rdata.unapprovedOrg[j].chainAddress })).then(Response => {
              if(Response.rdata.userImg) {
                this.unapprovedOrgimg.push(process.env.VUE_APP_URL_USER_THUMBNAIL + Response.rdata.userImg.imgSequence)
              } else {
                this.unapprovedOrgimg.push('')
              }
            })
          }
        }

        if (response.rdata.tempOrg !== undefined && response.rdata.tempOrg !== null) {
          this.tempOrg = response.rdata.tempOrg
          this.orgList.push(response.rdata.tempOrg)

          userBaseData = { header: '인증 대기 기업' }
          this.userList.push(userBaseData)

          userBaseData = {
            text: this.tempOrg.organizationRegistrationNumber,
            chainAddress: this.tempOrg.chainAddress,
            name: this.tempOrg.organizationName,
            group: '기업',
            avatar: '',
            index: this.userList.length + 1,
            TempGroup: true
          }
          this.userList.push(userBaseData)
        }
      })
    },

    selectUser(data) {
      this.userGubun = data.group
      if(data.TempGroup) {
        this.tempOrgYN = true
        // 기업 정보
        this.focusOrgInfo.organizationName = this.tempOrg.organizationName
        this.focusOrgInfo.creationDatetimesubstr = this.tempOrg.creationDatetime
        this.focusOrgInfo.organizationRegistrationNumber = this.tempOrg.organizationRegistrationNumber
        this.focusOrgInfo.presidentName = this.tempOrg.presidentName
        this.focusOrgInfo.organizationAddress = this.tempOrg.organizationAddress
        this.focusOrgInfo.organizationContact = this.tempOrg.organizationContact
        this.focusOrgInfo.organizationSequence = this.tempOrg.organizationSequence
        this.focusOrgInfo.chainAddress = this.tempOrg.chainAddress
        this.focusOrgInfo.avatar = data.avatar
        this.focusOrgInfo.organizationEmail = '-'
        // 기업 관리자
        this.adminUsrId = ''
        this.adminUsrName = '기업인증을 진행해 주세요'
        this.adminUsrEmail = ''
        // 전자계약 관리자
        this.cadminUsrId = ''
        this.cadminUsrName = '기업인증을 진행해 주세요'
        this.cadminUsrEmail = ''
      } else {
        this.tempOrgYN = false
        if(data.group === '기업') {
          // 기업정보 받아오는 곳
          getUserInfo(JSON.stringify({ userid: this.user.userid })).then(Response => {
            getOrgInfo(JSON.stringify({ accessId: Response.rdata.user.id, accessUsrID: this.orgList[data.index].creationUserId, accessOrgId: this.orgList[data.index].organizationSequence })).then(response => {
              if(response.rdata.CadminInfo.userId === this.user.userid || response.rdata.adminUsrInfo.userId === this.user.userid) {
                this.isAdmin = true
              } else {
                this.isAdmin = false
              }
              // 기업 정보
              this.focusOrgInfo.organizationName = response.rdata.atvOrgInfo.organizationName
              this.focusOrgInfo.creationDatetimesubstr = response.rdata.atvOrgInfo.creationDatetime
              this.focusOrgInfo.organizationRegistrationNumber = response.rdata.atvOrgInfo.organizationRegistrationNumber
              this.focusOrgInfo.presidentName = response.rdata.atvOrgInfo.presidentName
              this.focusOrgInfo.organizationAddress = response.rdata.atvOrgInfo.organizationAddress
              this.focusOrgInfo.organizationContact = response.rdata.atvOrgInfo.organizationContact
              this.focusOrgInfo.organizationSequence = response.rdata.atvOrgInfo.organizationSequence
              this.focusOrgInfo.chainAddress = response.rdata.atvOrgInfo.chainAddress
              this.focusOrgInfo.avatar = data.avatar

              for(var i in response.rdata.orgUserlist) {
                if (response.rdata.orgUserlist[i].userId === this.user.userid) {
                  this.focusOrgInfo.organizationEmail = response.rdata.orgUserlist[i].userEmail
                }
              }

              // 기업 관리자
              this.adminUsrId = response.rdata.adminUsrInfo.id
              this.adminUsrName = response.rdata.adminUsrInfo.userName
              this.adminUsrEmail = '(' + response.rdata.adminUsrInfo.userEmail + ')'
              // 전자계약 관리자
              this.cadminUsrId = response.rdata.CadminInfo.id
              this.cadminUsrName = response.rdata.CadminInfo.userName
              this.cadminUsrEmail = '(' + response.rdata.CadminInfo.userEmail + ')'
            })
          })
        }
      }
    },

    // 이미지 추가 버튼 클릭시 ChainAddress 가져옴
    addImg(ChainAddress, avatar) {
      this.dialogImg = true
      this.imgAvatar = avatar
      this.imgChainAddress = ChainAddress
    },

    // 이미지 선택시 data 저장
    UserImgUpload () {
      if(this.userImg.size > 5000000) {
        this.$refs.confirm.open('alert', '이미지 저장', '5MB 이하의 이미지만 등록 가능합니다.').then(() => {
          this.userImg=[]
        })
      } else {
        const data = new FormData()
        data.append('file', this.userImg)
        data.append('chainAddress', this.imgChainAddress)
        this.ImgData = data
      }
    },

    // 이미지 저장
    uploadImg() {
      this.$refs.loading.start('입력 정보 확인 중')
      uploadUserImg(this.ImgData).then(response => {
        if (response.rcode === 20000) {
          this.$refs.loading.end()
          this.$refs.confirm.open('alert', '이미지 저장', '이미지가 변경되었습니다.').then(() => {
            location.reload();
          })
        }
      })
    },

    // 이미지 삭제
    deleteImg() {
      this.$refs.confirm.open('confirm', '이미지 삭제', '이미지를 삭제하시겠습니까?').then(() => {
      this.$refs.loading.start('입력 정보 확인 중')
        deleteUserImg({ chainAddress: this.imgChainAddress }).then(Response => {
            this.$refs.loading.end()
            this.$refs.confirm.open('alert', '이미지 삭제', '이미지가 삭제되었습니다.').then(() => {
            location.reload();
          })
        })
      })
    },

    // 기업 / 전자계약관리자 변경전 List 조회
    transferOrgAdminPopup (adminId, type) {
      this.dialog03 = true
      this.transferType = type
      this.orgUsrList = []
      this.searchkeyword = ''
      this.formTotal = 0
      this.pageParam.page = 0

      getOrgInfo({ accessUsrID: this.accountform.userid, accessOrgId: this.focusOrgInfo.organizationSequence, searchkeyword: this.searchkeyword, pageSize: this.pageParam.size, page: this.pageParam.page }).then(Response => {
        if (Response.rdata !== undefined && Response.rdata.rcode === 20000) {
          this.transferAdminId = adminId
          this.transferIndex = ''
          this.orgUsrList = []
          this.orgUsrImgList = []
          var firstPage = false

          for (var k in Response.rdata.orgUserlist) {
            if (Response.rdata.orgUserlist[k].userId === adminId) {
              firstPage = true
            }
            if (Response.rdata.imgList[k] != null) {
              this.orgUsrImgList.push(process.env.VUE_APP_URL_USER_THUMBNAIL + Response.rdata.imgList[k].imgSequence)
            }


            this.orgUsrList.push({
              id: Response.rdata.orgUserlist[k].id,
              userAddress: Response.rdata.orgUserlist[k].userAddress,
              userCtr: Response.rdata.orgUserlist[k].userCtr,
              userEmail: Response.rdata.orgUserlist[k].userEmail,
              userId: Response.rdata.orgUserlist[k].userId,
              userName: Response.rdata.orgUserlist[k].userName,
              createDate: Response.rdata.orgUserlist[k].createDate,
              teamName: Response.rdata.orgUserPartInfolist[k],
              chainAddress: Response.rdata.orgUserlist[k].chainAddress
            })
          }

          this.mangerViewVisble = true
          if (firstPage) {
            this.transferIndex = 0
          }
          this.formTotal = Response.rdata.totalCont
          this.pageParam.page = 1
        } else {
        }
      })
    },

    // 기업 / 전자계약관리자 변경
    changeOrgAdmin () {
      if (this.changeOrgAdminList.length) {
        this.$refs.loading.start('입력 정보 확인 중')
        transferAdminUser({ type: this.transferType, orgSeq: this.focusOrgInfo.organizationSequence, newAdminSeq: this.changeOrgAdminList[0].id, newAdminId: this.changeOrgAdminList[0].userId }).then(Response => {
          if (Response.rdata !== undefined && Response.rdata.rcode === 20000) {
            this.$refs.loading.end()
            this.mangerViewVisble = false
              if (this.transferType) {
                this.$refs.confirm.open('alert', '관리자 변경', '기업 관리자 변경이 완료되었습니다.')
              } else {
                this.$refs.confirm.open('alert', '관리자 변경', '전자계약관리자 변경이 완료되었습니다.')
              }
              this.checkOrgAdminList = []
              this.dialog03 = false
              this.userList = [] // list
              // 기업 정보
              this.userGubun = ''
              this.focusOrgInfo.organizationName = ''
              this.focusOrgInfo.creationDatetimesubstr = ''
              this.focusOrgInfo.organizationRegistrationNumber = ''
              this.focusOrgInfo.presidentName = ''
              this.focusOrgInfo.organizationAddress = ''
              this.focusOrgInfo.organizationContact = ''
              this.focusOrgInfo.organizationSequence = ''
              this.focusOrgInfo.chainAddress = ''
              this.focusOrgInfo.avatar = ''
              this.getOrgList()
            } else {
              this.$refs.loading.end()
              this.checkOrgAdminList = []
              this.mangerViewVisble = false
              var msg = ''
              if (Response.rdata === undefined) {
                msg = Response.message
              } else {
                msg = Response.rdata.message
              }
              this.cancelAlert(msg)
            }
          })
        this.changeOrgAdminList=[]
      } else {
        this.$refs.confirm.open('alert', '관리자 변경', '변경할 관리자를 선택해 주세요.')
      }
    },

    addOrgAdmin(data) {
      if(this.changeOrgAdminList.length >= 1) {
        this.$refs.confirm.open('alert', '관리자 변경', '1명만 선택 가능합니다.').then(() => {
          this.checkOrgAdminList=[]
          this.changeOrgAdminList=[]
        })
      } else {
        this.changeOrgAdminList.push(data)
      }
    },
    cancelOrgAdmin() {
      this.dialog03 = false
      this.changeOrgAdminList=[]
      this.transferType=false
    },

    // 기업 계약 이메일 변경
    orgMailPopup () {
      this.dialog04 = true
    },
    editContractMail () {
      if (this.$refs.emailRules.validate()) {
        this.$refs.loading.start('입력 정보 확인 중')
        editOrgEmailinfo({ orgSeq: this.focusOrgInfo.organizationSequence, email: this.editContrctEmail }).then(Response => {
          if (Response.rdata !== undefined && Response.rdata.rcode === 20000) {
            this.$refs.loading.end()
            this.$refs.confirm.open('alert', '이메일 변경', '기업 계약 이메일 변경이 완료 되었습니다.')
            this.editContrctEmail = ''
            this.userGubun = ''
            this.dialog04 = false
            this.getOrgList()
          } else {
            this.$refs.loading.end()
            this.dialog04 = false
            var msg = ''
            if (Response.rdata === undefined) {
              msg = Response.message
            } else {
              msg = Response.rdata.message
            }
            this.$refs.confirm.open('alert', '이메일 변경', msg)
          }
        })
      } else {
        this.$refs.confirm.open('alert', '이메일 변경', '이메일 형식을 확인 해주세요.')
      }
    },

    // 사용자 정보 수정
    personInfo() {
      this.$refs.personInfo.open()
    },

    changePassword() {
      this.$refs.changePassword.open()
    },

    terminateMember() {
      this.$refs.terminateMember.open()
    },

    // 기업 생성
    addCpn() {
      this.$refs.addCpn.open()
    },

    // 온라인 기업 인증
    reqAuthQuestConfirm () {
      this.$refs.confirm.open('confirm', '기업인증', '기업 인증을 진행 중인 내용이있습니다. 이어서 인증을 진행하시겠습니까?').then(() => {
        this.$refs.pubCert.open()
      }).catch(e => {
        this.reqAuthCancelConfirm()
      })
    },
    // 기업 인증 수락
    purCertResult (result) {
      this.$refs.loading.start('기업인증 중입니다. 잠시만 기다려주세요.')
      authOrg({ chainPass: this.chainPass, pubkey: result.certPEM, rValue: result.rValue, signValue: result.signValue, hashValue: result.hashValue, companyName: result.username }).then(response => {
        this.$refs.loading.end()
        if (response.rcode === 20000 && response.rdata.success) {
          this.$refs.confirm.open('alert', '기업인증', '기업인증이 완료되었습니다.').then(() => {
            if (process.env.NODE_ENV === 'development') {
              window.location = "http://localhost:8088/main"
            } else {
              window.location = process.env.VUE_APP_REQUEST_URL + "/main"
            }
          })
        } else {
          this.$refs.confirm.open('alert', '기업인증', '기업인증에 실패했습니다. (ERR : ' + response.rdata.message + ')').then(() => {
            if (process.env.NODE_ENV === 'development') {
              window.location = "http://localhost:8088/main"
            } else {
              window.location = process.env.VUE_APP_REQUEST_URL + "/main"
            }
          })
        }
      }).catch(() => {
        this.$refs.loading.end()
        this.$refs.confirm.open('alert', '기업인증', '기업인증에 실패했습니다.')
      })
    },
    // 기업 인증 취소
    reqAuthCancelConfirm () {
      this.$refs.confirm.open('confirm', '기업인증', '기업 인증을 취소하시겠습니까? 진행 중인 정보가 삭제됩니다.').then(() => {
        this.$refs.loading.start('입력 정보 확인 중')
        removeRequestTempOrginfo({}).then(Response => {
          this.$refs.loading.end()
          if (Response.rdata !== undefined && Response.rdata.rcode === 20000) {
            this.$refs.confirm.open('alert', '기업 인증', '진행 중인 기업 인증이 취소되었습니다.')
            this.getOrgList()
          } else {
            var msg = '기업 인증 취소에 실패하였습니다. 고객센터로 문의하세요.'
            if (Response.rdata === undefined) {
              msg = Response.message
            } else {
              msg = Response.rdata.message
            }
            this.$refs.confirm.open('alert', '기업 인증', msg)
            this.getOrgList()
          }
        })
      })
    },

    // 기업 참여 요청
    submitOrgGroupUser () {
      if (this.formSearchReqGroupOrg.organizationSequence !== '') {
        this.createOrgGroupUser(this.formSearchReqGroupOrg.organizationSequence)
        this.getOrgList()
        this.joinCpn = false
      } else {
        this.$refs.confirm.open('alert', '기업 참여', '참여요청할 기업을 검색하세요.')
      }
    },
    createOrgGroupUser (organizationSequence) {
      this.$refs.loading.start('입력 정보 확인 중')
      createOrgGroupUser(JSON.stringify({ organizationSequence: organizationSequence, email: '' })).then(Response => {
        if (Response.rdata.rcode === 20000) {
          this.$refs.loading.end()
          this.$refs.confirm.open('alert', '기업 참여', '기업 참여 요청이 완료되었습니다.')
          this.formSearchReqGroupOrg.organizationName = ''
          this.formSearchReqGroupOrg.organizationRegistrationNumber = ''
          this.formSearchReqGroupOrg.presidentName = ''
          this.formSearchReqGroupOrg.organizationAddress = ''
          this.formSearchReqGroupOrg.organizationContact = ''
          this.formSearchReqGroupOrg.organizationSequence = ''
          this.searchReqRegNum = ''
          this.initDialog()
          this.getOrgList()
        } else {
          this.$refs.loading.end()
          var msg = ''
          if (Response.rdata === undefined) {
            msg = Response.message
          } else {
            msg = Response.rdata.message
          }
          this.$refs.confirm.open('alert', '기업 참여', msg)
        }
      })
    },
    initDialog () {
      this.formSearchReqGroupOrg.organizationName = ''
      this.formSearchReqGroupOrg.organizationRegistrationNumber = ''
      this.formSearchReqGroupOrg.presidentName = ''
      this.formSearchReqGroupOrg.organizationAddress = ''
      this.formSearchReqGroupOrg.organizationContact = ''
      this.formSearchReqGroupOrg.organizationSequence = ''
      this.formSearchReqGroupOrg.organizationimg = ''
    },
    // 기업 참여요청 -> 검색 기능
    isValidRegNumforReqGroup () {
      this.formSearchReqGroupOrg.organizationName = ''
      this.formSearchReqGroupOrg.organizationRegistrationNumber = ''
      this.formSearchReqGroupOrg.presidentName = ''
      this.formSearchReqGroupOrg.organizationAddress = ''
      this.formSearchReqGroupOrg.organizationContact = ''
      this.formSearchReqGroupOrg.organizationSequence = ''
      var regChecks = '^[0-9]*$'
      var chainAddress = ''

      if (this.searchReqRegNum === '') {
        this.$refs.confirm.open('alert', '검색', '사업자 번호를 입력하세요')
      } else if (!this.searchReqRegNum.match(regChecks)) {
        this.$refs.confirm.open('alert', '검색', '숫자만 입력하세요')
      } else if (this.searchReqRegNum.length !== 10) {
        this.$refs.confirm.open('alert', '검색', '사업자 번호는 10자리입니다')
      } else {
        this.$refs.loading.start('입력 정보 확인 중')

        orgNumSearchList(JSON.stringify({ regNum: this.searchReqRegNum })).then(Response => {
          if (Response.rdata.rcode === 20000) chainAddress = Response.rdata.orginfo.chainAddress
          getUserImgList(JSON.stringify({ chainAddress: chainAddress })).then(response => {
            if (Response.rdata.rcode === 20000) {
              this.$refs.loading.end()
              if (Response.rdata.orguserCount > 0) {
                this.formSearchReqGroupOrg.organizationName = Response.rdata.orginfo.organizationName
                this.formSearchReqGroupOrg.organizationRegistrationNumber = Response.rdata.orginfo.organizationRegistrationNumber
                this.formSearchReqGroupOrg.presidentName = Response.rdata.orginfo.presidentName
                this.formSearchReqGroupOrg.organizationAddress = Response.rdata.orginfo.organizationAddress
                this.formSearchReqGroupOrg.organizationContact = Response.rdata.orginfo.organizationContact
                this.formSearchReqGroupOrg.organizationSequence = Response.rdata.orginfo.organizationSequence
                if(response.rdata.userImg) {
                  this.formSearchReqGroupOrg.organizationimg = process.env.VUE_APP_URL_USER_THUMBNAIL + response.rdata.userImg.imgSequence
                } else {
                  this.formSearchReqGroupOrg.organizationimg = ''
                }
              } else {
                if (Response.rdata.resultCode === 1) {
                  this.$refs.confirm.open('confirm', '관리자 등록', '기존의 등록된 기업정보가 있습니다. 해당 기업의 관리자로 연결하시겠습니까?').then(() => {
                    this.updateOrgAdminUser(Response.rdata.orginfo.organizationSequence)
                  })
                } else {
                  this.$refs.confirm.open('alert', '기업 인증', '인증 심사 중인 기업입니다. 인증 완료 후 가입요청을 하시거나, 고객센터로 문의 바랍니다.')
                }
              }
            } else {
              this.$refs.loading.end()
              this.$refs.confirm.open('confirm', '기업 등록', '등록된 기업이 없습니다. 기업을 생성하시겠습니까').then(() => {
                this.createOrgView()
              })
            }
          })
        })
      }
    },

    // 기업 참여 요청 -> 기존의 등록된 기업정보가 있습니다.
    updateOrgAdminUser (organizationSequence) {
      this.$refs.loading.start('입력 정보 확인 중')
      updateOrgAdminUser({ organizationSequence: organizationSequence }).then(Response => {
        if (Response.rdata !== undefined && Response.rdata.rcode === 20000) {
          this.$refs.loading.end()
          this.$refs.confirm.open('alert', '기업 등록', '기업 관리자 등록이 완료되었습니다')
          this.getOrgList()
        } else {
          this.$refs.loading.end()
          var msg = ''
          if (Response.rdata === undefined) {
            msg = Response.message
          } else {
            msg = Response.rdata.message
          }
          this.$refs.confirm.open('alert', '기업 등록', msg)
        }
      })
    },
    // 기업 참여 요청 -> 등록된 기업이 없습니다.
    createOrgView () {
      if (!this.tempOrg) {
        this.$refs.addCpn.open()
      } else {
        this.$refs.confirm.open('alert', '기업 등록', '등록중인 내용이있습니다. 기업 인증을 완료하세요.').then(e => {
          this.joinCpn = false
        })
      }
    },
    // 기업 정보 수정
    companyInfo() {
      this.$refs.companyInfo.open()
    },
    // 기업 참여 요청 Popup
    clickCpn() {
      this.joinCpn = true
    },
    // 요청 현황 Popup
    requestCpn() {
      this.$refs.requestCpn.open()
    },

    leaveOrgQuest (orgSeq, orgName) {
      this.$refs.confirm.open('confirm', '기업 탈퇴', orgName + ' 기업을 탈퇴 하시겠습니까?').then(() => {
        this.selectRowisLastuser(orgSeq, orgName)
      })
    },
    selectRowisLastuser (orgSeq, orgName) {
      this.$refs.loading.start('입력 정보 확인 중')
      isLastUser({ organizationSequence: orgSeq }).then(Response => {
        if (Response.rdata !== undefined && Response.rdata.rcode === 20000) {
          this.$refs.loading.end()
          if (Response.rdata.count > 1) {
            if (Response.rdata.isAdmin) {
              this.$refs.confirm.open('confirm', '기업 탈퇴', orgName + '의 기업 관리자 입니다. 기업 탈퇴를 원하실 경우 관리자를 변경해 주세요. 관리자를 변경하지 않으면 가입 순서에 따라 ' + '다음 기업 관리자를 ' + Response.rdata.nextAdmin + '사용자로 변경합니다. 계속 진행하시겠습니까?').then(() => {
                this.selectRowOrgOut(orgSeq)
              }).catch(e => {
              })
            } else if (Response.rdata.isCadmin) {
              this.cancelAlert(orgName + '의 전자계약 관리자 입니다. 기업 탈퇴를 원하실 경우 기업 관리자 ' + this.adminUsrName + '(' + this.adminUsrEmail + ')' + '님에게 전자계약 관리자 수정을 요청하여 주십시오.')
            } else {
              this.selectRowOrgOut(orgSeq)
            }
          } else {
            this.$refs.confirm.open('alert', '기업탈퇴', orgName + '기업의 마지막 사용자입니다. 마지막 사용자는 탈퇴 할 수 없습니다.')
          }
        } else {
          this.$refs.loading.end()
          var msg = ''
          if (Response.rdata === undefined) {
            msg = Response.message
          } else {
            msg = Response.rdata.message
          }
          this.$refs.confirm.open('alert', '기업탈퇴', msg)
        }
      })
    },
    selectRowOrgOut (orgSeq) {
      this.$refs.loading.start('입력 정보 확인 중')
      leaveOrgUser({ organizationSequence: orgSeq }).then(Response => {
        if (Response.rdata !== undefined && Response.rdata.rcode === 20000) {
          this.$refs.loading.end()
          this.$refs.confirm.open('alert', '기업탈퇴', '기업 탈퇴가 완료되었습니다')
          this.getOrgList()
        } else {
          this.$refs.loading.end()
          var msg = ''
          if (Response.rdata === undefined) {
            msg = Response.message
          } else {
            msg = Response.rdata.message
          }
          this.$refs.confirm.open('alert', '기업탈퇴', msg)
        }
      })
    },
    deleteOrgTemp (organizationRegistrationNumber, orgName) {
      this.$refs.confirm.open('confirm', '온라인 기업 인증 취소', orgName + ' 기업의 온라인 기업 인증을 취소 하시겠습니까?').then(() => {
        deleteOrgTemp({ orgTempNumber: organizationRegistrationNumber }).then(Response => {
          if (Response.rdata.rcode === 20000) {
            this.$refs.confirm.open('alert', '온라인 기업 인증 취소', '온라인 기업 인증 취소가 완료되었습니다').then(() => {
              location.reload();
            })
          } else {
            this.$refs.confirm.open('alert', '온라인 기업 인증 취소', '온라인 기업 인증 취소에 실패하였습니다<br>해당 메세지가 계속 나오면 관리자에게 문의하세요.')
          }
        })
      })
    }
  }
}
</script>
<style>
.pop_list_carD03 {
    max-height: calc(100vh - 24rem);
    overflow-y: auto;
    border-top: 1px solid #d7d8da;
    border-bottom: 1px solid #d7d8da;
}
.set_org_selPic{
  margin: 6px 16px;
}
.pattern_ulTxtBox.ofHmb20{
  overflow: hidden;
  margin-bottom: 20px;
}
.del_pic {
    z-index: 3;
    position: absolute;
    bottom: -6px;
    left: 50%;
    margin-left: 20px;
}
</style>
